import { useEffect, useState } from "react"; 
import { Link, useNavigate } from "react-router-dom";
import { Button, Form, Input } from "antd";
import { EyeOutlined, MailOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";

import styles from "./authen.module.css";
import { ResponseDataType, postRequest, getRequest } from "api";
import TermsPopup from "./TermsPopup";

interface LoginDataType {
  accessToken?: string;
  refreshToken?: string;
  customerId?: string;
}

export const LoginPage = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [openTerms, setOpenTerms] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);

  // 👉 thêm state để lưu email khi nhập
  const [emailValue, setEmailValue] = useState("");

  useEffect(() => {
    if (localStorage.getItem("email")) navigate("/");
  }, [navigate]);

  const handleShowLoginForm = () => {
    setShowLoginForm(true);
  };

  const Login = async (value: { email: string; password: string }) => {
    try {
      // Check trạng thái xác thực trước
      const checkRes: ResponseDataType<{ isVerified: boolean; status: number }> =
        await getRequest(
          `/customer/check-verification-status?email=${encodeURIComponent(
            value.email
          )}`
        );

      if (checkRes?.data?.status === 0) {
        // chưa xác thực → sang trang unconfirmation
        navigate("/unconfirmation", { state: { email: value.email } });
        return;
      }

      // Nếu đã xác thực thì mới cho login
      const response: ResponseDataType<LoginDataType> = await postRequest(
        "/auth/login",
        {
          email: value.email,
          password: value.password,
        }
      );

      if (response.code) {
        toast.error(response.message);
      } else if (response.data?.accessToken && response.data?.refreshToken) {
        localStorage.setItem("email", value.email);
        localStorage.setItem("accessToken", response.data.accessToken as string);
        localStorage.setItem("refreshToken", response.data.refreshToken as string);
        localStorage.setItem("customerId", response.data.customerId as string);

        window.location.href = "/";
      }
    } catch (error) {
      console.error("Lỗi đăng nhập:", error);
      toast.error("Đăng nhập thất bại!");
    }
  };

  return (
    <div className={styles.login_page}>
      <img className={styles.logo} src="/Images/logo.png" alt="" />
      <div className={styles.authen_wrapper}>
        <div className={styles.name}>Adot</div>
        <div className={styles.intro}>
          Phần mềm ghi chú và quản lý luồng công việc
        </div>
        {!showLoginForm ? (
          <Button
            type="primary"
            className={styles.authen_button}
            onClick={handleShowLoginForm}
          >
            Đăng nhập
          </Button>
        ) : (
          <Form form={form} onFinish={Login}>
            <div className={`${styles.form} authen-form`}>
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Cần nhập email!" },
                  { type: "email", message: "Cần nhập email đúng định dạng!" },
                ]}
                style={{ margin: 0 }}
              >
                <Input
                  prefix={<MailOutlined className={styles.icon} />}
                  placeholder="Email"
                  className={styles.customInputWrapper}
                  // 👉 update state khi nhập
                  onChange={(e) => setEmailValue(e.target.value)}
                />
              </Form.Item>
              <div className={styles.line} />
              <Form.Item
                name="password"
                rules={[{ required: true, message: "Cần nhập mật khẩu!" }]}
                style={{ margin: 0 }}
              >
                <Input.Password
                  prefix={<EyeOutlined className={styles.icon} />}
                  placeholder="Mật khẩu"
                  className={styles.customInputWrapper}
                />
              </Form.Item>
            </div>
            <Button
              type="primary"
              className={styles.authen_button}
              htmlType="submit"
            >
              Đăng nhập
            </Button>
          </Form>
        )}
        <div className={`${styles.text} ${styles.signup_link}`}>
          Chưa có tài khoản?&nbsp;
          <Link to="/sign-up" style={{ color: "black" }}>
            Đăng ký ngay
          </Link>
        </div>

        <div className={`${styles.text} ${styles.signup_link}`}>
          <Link
            to="/forgotPassword"
            state={{ email: emailValue }} // 👉 dùng state thay vì form.getFieldValue
            style={{ color: "black" }}
          >
            Quên mật khẩu?
          </Link>
        </div>
      </div>
      {openTerms && <TermsPopup closeTerms={() => setOpenTerms(false)} />}
    </div>
  );
};